"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash.throttle"));

var _reactVirtualized = require("react-virtualized");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _VirtualizedTable = _interopRequireDefault(require("../../VirtualizedTable"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    table: {
      margin: spacing(0, -2),
      position: 'relative',
      '& .ReactVirtualized__Table__headerColumn': {
        display: 'flex',
        alignItems: 'center'
      },
      '& .ReactVirtualized__Grid__innerScrollContainer': {
        margin: spacing(0, 2)
      },
      '& .ReactVirtualized__Table__row': {
        borderBottom: "1px solid ".concat(palette.divider),
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: '#eaecf1',
          '& [aria-label="select as the default gift"]': {
            display: 'block'
          }
        }
      },
      '& .ReactVirtualized__Table__rowColumn': {
        justifyContent: 'flex-start',
        color: palette.text.primary
      }
    },
    selectedProductRow: {
      backgroundColor: '#eaecf1'
    }
  };
});
/**
 * @typedef Product
 *
 * @property {number} id
 * @property {string} name
 * @property {number} price
 */

/**
 * @typedef FakeProduct
 *
 * @property {boolean} isFake
 */

/**
 * @callback handleProductClick
 * @param {Product} product
 *
 * @returns {void}
 */

/**
 * @callback handleLoadMoreProducts
 *
 * @returns {void}
 */

/**
 * Marketplace that renders products as a table.
 *
 * ! Marketplace calls props.loadMoreProducts when user scrolled marketplace to down.
 *
 * @param {object} props
 * @param {Array<Product | FakeProduct>} props.products - Products array.
 * @param {handleProductClick} props.onProductClick - On click to products callback.
 * @param {number} [props.defaultProductId=null] - Highlight chosen product.
 * @param {handleLoadMoreProducts} props.loadMoreProducts - On marketplace trying to load more products callback, by.
 * @param {React.ReactNode} props.children - Will rendered if marketplace is empty. Scrolling to the end.
 *
 * @returns {React.ReactNode}
 *
 * @example
 * export const CoffeeShop = () => {
 *   const [chosenProductId, setChosenProductId] = useState(undefined);
 *   const [products, setProducts] = useState([
 *     { id: 1, name: 'Espresso', image: 'https://picsum.photos/50' },
 *     { id: 3, name: 'Latte', image: 'https://picsum.photos/50' },
 *     { id: 4, name: 'Russiano', image: 'https://picsum.photos/50' },
 *   ]);
 *
 *   return (
 *     <SimpleMarketplace
 *       products={products}
 *       onProductClick={setChosenProduct}
 *       loadMoreProducts={useCallback(
 *           () => { setProducts(p => [...p, { id: 5, name: 'Amnesia Lemon', image: 'https://picsum.photos/50' }]) },
 *           []
 *         )
 *       }
 *       defaultProductId={chosenProduct}
 *     >
 *      Have not found any product
 *     </SimpleMarketplace>
 *   );
 * }
 */

var SimpleMarketplace = function SimpleMarketplace(_ref2) {
  var products = _ref2.products,
      onProductClick = _ref2.onProductClick,
      defaultProductId = _ref2.defaultProductId,
      loadMoreProducts = _ref2.loadMoreProducts,
      children = _ref2.children,
      virtualizedProps = (0, _objectWithoutProperties2["default"])(_ref2, ["products", "onProductClick", "defaultProductId", "loadMoreProducts", "children"]);
  var classes = useStyles();
  var getRowClassName = (0, _react.useCallback)(function (_ref3) {
    var index = _ref3.index;
    return (0, _classnames["default"])((0, _defineProperty2["default"])({}, classes.selectedProductRow, products[index] && defaultProductId === products[index].id));
  }, [classes.selectedProductRow, defaultProductId, products]);
  var getRowData = (0, _react.useCallback)(function (_ref4) {
    var index = _ref4.index;
    return products[index];
  }, [products]);
  var rowClickHandler = (0, _react.useCallback)(function (row) {
    var rowData = getRowData(row);

    if (!rowData.isFake) {
      onProductClick(rowData);
    }
  }, [getRowData, onProductClick]);
  var onScroll = (0, _react.useMemo)(function () {
    return (0, _lodash["default"])(function (_ref5) {
      var clientHeight = _ref5.clientHeight,
          scrollHeight = _ref5.scrollHeight,
          scrollTop = _ref5.scrollTop;

      if (scrollHeight - scrollTop <= clientHeight * 2 && loadMoreProducts) {
        loadMoreProducts();
      }
    }, 500);
  }, [loadMoreProducts]);
  var noRowsRenderer = (0, _react.useCallback)(function () {
    return children;
  }, [children]);
  var giftCellsRenderer = (0, _react.useCallback)(function (_ref6, width) {
    var rowData = _ref6.rowData,
        cellData = _ref6.cellData;
    return /*#__PURE__*/_react["default"].createElement(_material.Box, {
      display: "flex",
      alignItems: "center"
    }, rowData.isFake ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Skeleton, {
      variant: "circular",
      width: 30,
      height: 30
    }), /*#__PURE__*/_react["default"].createElement(_material.Box, {
      ml: 1
    }, /*#__PURE__*/_react["default"].createElement(_material.Skeleton, {
      variant: "rectangular",
      width: 180,
      height: 22
    }))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Avatar, {
      alt: cellData,
      src: rowData.image
    }), /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
      title: cellData,
      arrow: true,
      enterDelay: 500,
      disableFocusListener: true
    }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
      ml: 1,
      width: width * 0.75,
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden"
    }, cellData))));
  }, []);
  var priceCellsRenderer = (0, _react.useCallback)(function (_ref7) {
    var cellData = _ref7.cellData,
        rowData = _ref7.rowData;
    return rowData.isFake ? /*#__PURE__*/_react["default"].createElement(_material.Skeleton, {
      variant: "rectangular",
      width: 80,
      height: 22
    }) : cellData.toFixed(2);
  }, []);
  var actionCallsRenderer = (0, _react.useCallback)(function (_ref8) {
    var rowData = _ref8.rowData;
    return rowData.id === defaultProductId ? /*#__PURE__*/_react["default"].createElement(_material.Box, {
      color: "grey.main",
      fontSize: "0.75rem"
    }, "Selected as the default gift") : /*#__PURE__*/_react["default"].createElement(_material.Box, {
      display: "none",
      "aria-label": "select as the default gift",
      color: "grey.main",
      fontSize: "0.75rem"
    }, "Select as the default gift");
  }, [defaultProductId]);
  return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.AutoSizer, {
    disableHeight: true
  }, function (_ref9) {
    var width = _ref9.width;
    return /*#__PURE__*/_react["default"].createElement(_VirtualizedTable["default"], (0, _extends2["default"])({
      className: (0, _classnames["default"])(classes.table),
      rowClassName: getRowClassName,
      rowGetter: getRowData,
      rowHeight: 55,
      headerHeight: 40,
      maxVisibleRows: 6.5,
      width: width,
      onScroll: onScroll,
      rowCount: products.length,
      onRowClick: rowClickHandler,
      noRowsRenderer: noRowsRenderer,
      fixedHeight: true
    }, virtualizedProps), /*#__PURE__*/_react["default"].createElement(_reactVirtualized.Column, {
      label: "Gift",
      width: width * 0.58,
      dataKey: "name",
      cellRenderer: function cellRenderer(renderData) {
        return giftCellsRenderer(renderData, width * 0.58);
      }
    }), /*#__PURE__*/_react["default"].createElement(_reactVirtualized.Column, {
      label: "Price",
      width: width * 0.15,
      dataKey: "price",
      cellRenderer: priceCellsRenderer
    }), /*#__PURE__*/_react["default"].createElement(_reactVirtualized.Column, {
      label: "",
      width: width * 0.27,
      dataKey: "",
      cellRenderer: actionCallsRenderer
    }));
  });
};

SimpleMarketplace.propTypes = {
  defaultProductId: _propTypes["default"].number,
  onProductClick: _propTypes["default"].func.isRequired,
  children: _propTypes["default"].node.isRequired,
  products: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].shape({
    id: _propTypes["default"].number.isRequired,
    name: _propTypes["default"].string.isRequired,
    price: _propTypes["default"].number.isRequired
  }), _propTypes["default"].shape({
    isFake: _propTypes["default"].bool.isRequired
  })])).isRequired,
  loadMoreProducts: _propTypes["default"].func
};
SimpleMarketplace.defaultProps = {
  defaultProductId: null,
  loadMoreProducts: undefined
};

var _default = /*#__PURE__*/(0, _react.memo)(SimpleMarketplace);

exports["default"] = _default;